import { toReferentPriceEntry, type ReferentPriceEntry, type ReferentPriceEntryApi } from "../api/referent-prices";

type WholesaleOfferLike = {
  referent_price?: ReferentPriceEntryApi | null;
  referent_prices?: ReferentPriceEntryApi[] | null;
};

export function getOfferReferentPriceEntries(offer: WholesaleOfferLike | null | undefined): ReferentPriceEntry[] {
  if (!offer) return [];
  if (Array.isArray(offer.referent_prices) && offer.referent_prices.length > 0) {
    return offer.referent_prices.map(toReferentPriceEntry);
  }
  if (offer.referent_price) {
    return [toReferentPriceEntry(offer.referent_price)];
  }
  return [];
}

export type ReferentPriceSelection = {
  current: ReferentPriceEntry | null;
  upcoming: ReferentPriceEntry | null;
};

function enforceTime(entry: ReferentPriceEntry): number | null {
  if (!entry.enforceAt) return null;
  const parsed = Date.parse(entry.enforceAt);
  return Number.isFinite(parsed) ? parsed : null;
}

export function splitReferentPrices(
  entries: ReferentPriceEntry[] | null | undefined,
  now: Date = new Date(),
): ReferentPriceSelection {
  if (!Array.isArray(entries) || entries.length === 0) return { current: null, upcoming: null };

  const nowMs = now.getTime();
  let current: ReferentPriceEntry | null = null;
  let currentTime = Number.NEGATIVE_INFINITY;
  let upcoming: ReferentPriceEntry | null = null;
  let upcomingTime = Number.POSITIVE_INFINITY;

  for (const entry of entries) {
    const time = enforceTime(entry);
    if (time == null || time <= nowMs) {
      const candidateTime = time ?? Number.NEGATIVE_INFINITY;
      if (candidateTime >= currentTime) {
        current = entry;
        currentTime = candidateTime;
      }
    } else if (time < upcomingTime) {
      upcoming = entry;
      upcomingTime = time;
    }
  }

  return { current, upcoming };
}
